import HtmlTrans from 'components/shared/HtmlTrans';
import {
  StyledSection,
  StyledSectionChart,
  StyledSectionContent,
  StyledSectionTitle
} from './Methodology.styled';
import { MethodologySectionProps } from './Methodology.types';

const MethodologySection: React.FC<MethodologySectionProps> = ({
  title,
  desc,
  chart,
  accordion
}) => {
  return (
    <StyledSection>
      <StyledSectionContent>
        <StyledSectionTitle>{title}</StyledSectionTitle>
        <div>
          <HtmlTrans ns="developer-career-report-2025" i18nKey={desc} />
        </div>
        {accordion && <>{accordion}</>}
      </StyledSectionContent>
      <StyledSectionChart>{chart}</StyledSectionChart>
    </StyledSection>
  );
};

export default MethodologySection;
